import { InjectionToken } from '@angular/core';

import type { InitialLocation } from './initial_location';
import type { IntegrationKinds } from './integrations';

export const INTEGRATIONS_FEATURE_FLAGS = new InjectionToken<Record<string, boolean>>(
  'integrations feature flags',
);
export const ENABLED_INTEGRATION_KINDS = new InjectionToken<IntegrationKinds[]>(
  'ENABLED_INTEGRATION_KINDS',
);
export const INITIAL_LOCATION = new InjectionToken<InitialLocation>('INITIAL_LOCATION');
